import { useSelector } from 'react-redux';

/**
 *
 * @returns {{ roleId: (number | null); roleName: (string | null); isUserGroupAdmin: boolean }}
 */
export const useUserGroupRole = () => {
    /** @type {{roleId: (number | null); roleName: (string | null)}} */
    const { roleId, roleName } = useSelector((state) => ({
        // TODO: Ask Oleg about how we want to enforce this -- via db or by cognito.
        // Technically, the below doesn't work as expected, but we need clarification
        // on how to enforce before we make a change. As of writing, this isn't affecting users.
        //
        // "Correct" Check
        // --
        // roleId: state.auth?.data?.WalletUserSettings?.roleId,
        // roleName: state.auth?.data?.WalletUserSettings?.roleName,
        // --
        roleId: state.auth?.data?.WalletUserSettings?.cognitoGroup,
        roleName: state.auth?.data?.WalletUserSettings?.cognitoGroup,
    }));

    const isUserGroupAdmin = roleName?.toLowerCase() === 'usergroup_admin';

    return {
        roleId,
        roleName,
        isUserGroupAdmin,
    };
};
